import React from "react";
import "../../styles/desktop/textoMain.css";
import Icone from "../../assets/img/icone-automacao.png";

const Header = () => {
  return (
    <div className="container">
      <h1 id="texto-main">
        Sistema de Automação Predial
        <img id="icone-automacao" src={Icone} alt="Ícone de automação" />
      </h1>
    </div>
  );
};

export default Header;
